module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('VAside', {
    attrs: {
      "sidebar-menus": _vm.sidebarMenus,
      "headerHeight": "50"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ac4f80b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/registry_manage/registry_manage.vue
// module id = 1399
// module chunks = 1